import { Button, Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import styles from './OnboardInvitationSentModal.module.scss';
import { Props } from './OnboardInvitationSentModal.types';

const OnboardInvitationSentModal = ({ open, assetId }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const onClose = () => navigate(`/asset/${assetId}/admin`);

  return (
    <Modal
      opened={open}
      onClose={onClose}
      title={t('onboarding.invitationSentModalTitle', 'Invitations envoyées 🚀')}
      withCloseButton={false}
    >
      <div className={styles.container}>
        <p className={styles.subtitle}>
          {t(
            'onboarding.invitationsSent',
            "Vos co-gérants ont reçu un mail d'invitation pour accéder à la plateforme"
          )}
        </p>
        <Button onClick={onClose}>{t('onboarding.goToApp', 'Accéder à la plateforme')}</Button>
      </div>
    </Modal>
  );
};

export default OnboardInvitationSentModal;
